import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart } from 'chart.js';
import "chart.js/auto";
import func from "../../services/functions";
import { useTranslation } from "react-i18next";
import { DashboardCard } from "../global/CommonComponents";

const DoughnutPieTable = ({ title, todayTotalsByBranch, businessUnitCodes }) => {
  const { t } = useTranslation('translations');
  const doughnutRef = React.useRef();
  let filteredTotalsByBranch=todayTotalsByBranch=todayTotalsByBranch?.filter(stat=>((stat.cashEnd?? 0) +(stat.banknoteCashTot ?? 0))>0)
  let labels=filteredTotalsByBranch?.map(stat=>{ return businessUnitCodes.find((branch=>branch.value==stat.businessUnitCode))?.label?.trim() ?? stat.businessUnitCode}) ?? [];
  let dataSet=filteredTotalsByBranch?.map(stat=>(stat.cashEnd+ 0) +(stat.banknoteCashTot)) ?? []
  let isEmpty=dataSet.every(cashEnd=>cashEnd===0);
  const hoverLabel={
    id:"hoverLabel",
    afterDraw(chart){
      if(!chart.config?.options?.plugins?.hoverLabel) return
      const {ctx,chartArea:{left,top,width,height}} =chart
      ctx.save()
      let active=0
      let dataSetIndex=0
      if(chart._active.length>0){
        active=chart._active?.[0].index
        dataSetIndex=chart._active?.[0].datasetIndex
      }
        const textLabel=chart.config.data.labels[active]
        const numberLabel=chart.config.data.datasets[dataSetIndex].data[active]
        ctx.textAlign="center"
        ctx.textBaseline="middle"
        const centerX = left + width / 2
        const centerY = top + height / 2
        if(textLabel && numberLabel){
          let branchName=textLabel.split("| ")?.[0] ?? textLabel
          // Truncate branch name if too long
          if (branchName.length > 12) {
            branchName = branchName.substring(0, 11) + "..."
          }
          ctx.font = "600 13px -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          ctx.fillStyle="#6b7280"
          ctx.fillText(branchName, centerX, centerY - 12)
          ctx.font = "700 18px -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          ctx.fillStyle="#007567"
          ctx.fillText(`${func.getFormattedMoneyValue(numberLabel)} L`, centerX, centerY + 12)
        }else{
          ctx.fillStyle="#9ca3af"
          ctx.font = "600 14px -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          ctx.fillText(t("dashboard.noData"), centerX, centerY)
        }

      ctx.restore()
    }
  }

  Chart.register(hoverLabel);

  const colors=[
    "#36c9c6",
    "#fac091",
    "#5075df",
    "#1cbb8c",
    "#eeb902",
    "#508991",
    "#f4f1bb",
    "#f9a825",
    "#9bc1bc",
    "#508991",
    "#f4f1bb",
    "#f9a825",
    "#9bc1bc",
    "#ff9b85",
    "#b8b8ff"
  ]
  const data = {
    labels: isEmpty?[]:labels,
    datasets: [
      {
        label: "My First Dataset",
        data: isEmpty?[1]:dataSet,
        backgroundColor: colors,
        hoverBorderColor :"#ececec",
        hoverBorderWidth:3,
        spacing:4,
      },
    ],
  };

  const config = {
    responsive: true,
    cutout: isEmpty ? "70%" : "65%",
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        usePointStyle: true,
        enabled: !isEmpty,
        callbacks: {
          label: (ctx) => ` ${ctx.label}: ${func.getFormattedMoneyValue(ctx.raw)} L`
        }
      },
      legend: {
        display: false,
      },
      hoverLabel,
    }
  };


  return (
    <DashboardCard title={title}>
      <div className="d-flex align-items-center justify-content-center h-100 w-100">
        <div className="dougnut-chart" style={{ width: "100%", maxWidth: 280, padding: 8 }}>
          <Doughnut data={data} options={config} ref={doughnutRef} />
        </div>
      </div>
    </DashboardCard>
  );
};

export default React.memo(DoughnutPieTable);
